import { render, staticRenderFns } from "./PatientCoachingSummary.vue?vue&type=template&id=bf0e600c"
import script from "./PatientCoachingSummary.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports